import React from 'react';
import Layout from '@/components/layout/Layout';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ProductTab } from '@/components/settings/product/ProductTab';
import { ProductVariationsTab } from '@/components/settings/product/ProductVariationsTab';

const ManageBenchmarkProducts: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="container mx-auto py-6 space-y-6">
        <div className="flex items-center gap-4">
          <Button variant="outline" size="sm" onClick={() => navigate('/price-benchmarking/manage-data')} className="gap-2">
            <ArrowLeft className="h-4 w-4" />
            Back
          </Button>
          <div>
            <h1 className="text-2xl font-bold">Manage Benchmark Products</h1>
            <p className="text-muted-foreground">Add, edit, and manage products and their name variations used in benchmark data entry</p>
          </div>
        </div>

        <Tabs defaultValue="products" className="w-full">
          <TabsList>
            <TabsTrigger value="products">Products</TabsTrigger>
            <TabsTrigger value="variations">Name Variations</TabsTrigger>
          </TabsList>
          <TabsContent value="products">
            <ProductTab hideDelete />
          </TabsContent>
          <TabsContent value="variations">
            <ProductVariationsTab />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
};

export default ManageBenchmarkProducts;
